// keyCodes (ev.keyCode, now depracated)
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
export const ESC = 27;
export const ENTER = 13;
export const TAB = 9;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
export const ARROW_LEFT = 37;
export const ARROW_RIGHT = 39;
